import React, { Component } from "react";
import "./Popup.scss";

export default class PopupError extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <div className="container">
                <div className="close" onClick={() => this.props.togglePopup(null)}></div>
                <div className="headline">
                    <div className="head">
                        היי!
                            </div>
                    <div className="desc">
                        לפי הצהרות המפלגות,
                        
                        {" " + this.props.partOne + " "}
                         לא תהיה חלק מהקואליציה שהרכבת
                            </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Popup/PopupError.jsx